var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishingFortune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 295.3 295.3",
    style: {
      enableBackground: "new 0 0 295.3 295.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 126.3,
    cy: 161.3,
    r: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.2,174.6c0-8.4,4.4-14.6,8.2-20.2c3.8-5.5,7.7-11.1,5-17.4c-1.6-3.6-5.2-5.8-9.9-5.9 c-6-0.1-13.8,3-21.3,8.6c-4.4,3.3-10.2,8.5-15.4,16.1c-6.2-7-14.6-13.9-24.1-19.7c0.3-6.9-0.1-19.8-6.3-26.8 c-2.8-3.1-6.5-4.8-10.7-4.8c-14.8,0-34.7,7.3-45.1,16.3c-18.3,1.8-33.5,8.7-43.6,14.7c-13.3,7.9-24.7,18.3-30.7,27.8l-2.5,4 l6.9,7.2l-6.9,7.2l2.5,4c6,9.5,17.5,19.9,30.7,27.8c9.8,5.8,24.5,12.6,42.2,14.6c9.8,9.5,31,17.6,46.5,17.6c4.2,0,7.9-1.7,10.7-4.8 c6.6-7.3,6.6-21.3,6.2-27.9c9.5-5.7,18-12.7,24.1-19.7c5.2,7.6,11,12.8,15.4,16.1c7.4,5.5,15,8.6,21,8.6c0.1,0,0.3,0,0.4,0 c4.7-0.1,8.2-2.3,9.9-5.9c2.8-6.3-1.1-12-5-17.4C285.5,189.2,281.2,183,281.2,174.6z M208.2,117.6c1.9,2.1,2.8,7,3.1,12 c-7.5-3.4-16.5-6.4-26.5-8c7.3-2.8,15.4-4.7,21.9-4.7C207.3,116.9,207.7,117,208.2,117.6z M206.7,233.5c-7.1,0-16.1-2.2-23.9-5.5 c10.9-1.5,20.6-4.7,28.6-8.4c-0.3,6.8-1.8,11.7-3.2,13.2C207.7,233.3,207.3,233.5,206.7,233.5z M216.6,203 c-10.3,6.2-26.7,13.5-46.2,13.5c-7.2,0-13.9-1-20.1-2.6c7.9-11.5,12.1-25.2,12.1-39.3c0-11.1-2.5-21.7-7.5-31.5l-11,5.6 c4.1,8.1,6.2,16.8,6.2,26c0,12.8-4.3,25.2-12.1,35.3c-5.3-2.1-9.9-4.6-13.7-6.8c-11.1-6.6-19.1-14.1-23.8-19.9l8.1-8.5l-8.1-8.5 c4.7-5.9,12.7-13.3,23.8-19.9c10.3-6.1,26.7-13.4,46.1-13.4c19.5,0,35.9,7.3,46.2,13.5c12.3,7.3,20.7,15.6,25.1,21.7 c-0.5,2.3-0.7,4.8-0.8,6.1l0,0.3l0,0.3c0,1.5,0.2,4.1,0.8,6.7C237.2,187.4,228.8,195.7,216.6,203z M271.7,200.5 c-7.3-5.1-13.6-12.4-17.8-20.7c-0.4-0.9-0.7-2.7-0.8-5.1c0.2-2,0.6-4.6,0.9-5.6c8-15.8,21.4-23.9,27.8-25.6 c-0.7,1.2-1.7,2.6-2.5,3.7c-4.4,6.3-10.4,15-10.4,27.2s6,20.9,10.4,27.2c0.8,1.1,1.7,2.5,2.5,3.7 C279.4,204.9,275.9,203.4,271.7,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.5,179.6l5.1-6.4v14.4c0,10.6-8.6,19.1-19.1,19.1s-19.1-8.6-19.1-19.1V49.5H0v138.1 c0,17.3,14.1,31.4,31.4,31.4s31.4-14.1,31.4-31.4V138l-27,34L45.5,179.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishingFortune);
export default __webpack_public_path__ + "static/media/FishingFortune.4652e3e9fae8f4bda2c6642621fcbd81.svg";
export { ForwardRef as ReactComponent };